<template>
  <el-dialog
    title="选择用户"
    :visible.sync="propsData.visible"
    :close-on-click-modal="false"
    class="topDialog chooseMultipleUserDialog"
    @close="closeDialog()"
    :close-on-press-escape="false">
    <div class="modalContent">
      <div class="tree">
        <div>
          <el-tree
            ref="tree"
            :key="tree_key"
            :data="treeData"
            node-key="id"
            :props="defaultProps"
            :expand-on-click-node="false"
            default-expand-all
            :highlight-current="true"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>

      <div class="rightDiv">
        <div class="" style="left:0px;right:0px;top:0px;bottom:0px;position: absolute;">
          <div class="" style="border: 1px solid #ebeef5;position: absolute;bottom: 50px;right: 0px;left:0px;top:0px;" id="tableContent">
            <el-table :data="userList" border stripe>
              <el-table-column type="index" width="50" label="NO" fixed="left"></el-table-column>
              <el-table-column prop="name" label="姓名" fixed="left">
                <template slot-scope="props">
                  <el-button
                    type="text"
                    size="mini"
                    @click="chooseUser(props.row)">{{props.row.name}}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="organizationName" label="组织机构"></el-table-column>
              <el-table-column prop="account" label="登录账户"></el-table-column>
              <!-- <el-table-column prop="Cellphone" label="工号"> </el-table-column> -->
              <el-table-column prop="cellphone" label="电话"></el-table-column>
              <el-table-column prop="email" label="邮箱"></el-table-column>
              <!-- <el-table-column prop="createTime" label="创建时间"></el-table-column> -->
            </el-table>
          </div>
           <div class="" style="position: absolute;bottom: 0;right: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.PagingInfo.currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="listQuery.PagingInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.PagingInfo.totalCount"
          ></el-pagination>
        </div>
        </div>
      </div>

    </div>

    <div class="userTextarea">
      <el-tag
        v-for="tag in selectedUser"
        :key="tag.name"
        closable
        @close="handleClose(tag)"
      >{{tag.name}}</el-tag>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="saveDialog()">保存</el-button>
      <el-button type="text" @click="closeDialog()">取消</el-button>
    </div>

  </el-dialog>
</template>
<script>
export default {
  name: "chooseMultipleUser",
  components: {},
  props: ["propsData", "roleForm"],
  data() {
    return {
      treeData: [],
      tree_key: 0,
      filterText: "",
      isActive: true,
      departmentVisible: false,
      chooseVisible: false,
      isEdit: false,
      isUserEdit: false,
      organizationInfo: {
        id: "",
        parentId: "",
        numericalOrder: 0,
        name: ""
      },
      userList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          organizationId: "",
          organizationIdPath: "",
          keyword: ""
        }
      },
      selectedUser: [],
      selectUserLisr: [],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },

  methods: {
    show(){
        this.selectedUser = [];
       this.propsData.visible = true;
       this.getOrganizationTree();
    },

    getOrganizationTree() {
      this.$organizationApi.getOrganizationTree().then(res => {
        this.treeData = [];
        if (res.data.successful) {
          this.treeData = res.data.data;
          // this.listQuery.Parameters.organizationId = this.treeData[0].id;
          this.listQuery.Parameters.organizationIdPath = this.treeData[0].id;
          this.getUserList();
        } else {
          this.$alert("获取组织机构失败！", "提示");
        }
      });
    },

    closeDialog(formName) {
      this.propsData.visible = false;
       document.getElementById('tableContent').scrollTop = 0;
    },
    handleNodeClick(data) {
      // this.listQuery.Parameters.organizationId = data.id;
      this.listQuery.Parameters.organizationIdPath = data.id;
      this.getUserList();
    },

    // 用户
    getUserList() {
      this.$userApi.getUserList(this.listQuery).then(res => 
      {
        if (res.data.successful) 
        {
          this.userList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } 
        else 
        {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    handleSizeChange(val) 
    {
      this.listQuery.PagingInfo.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) 
    {
      this.listQuery.PagingInfo.currentPage = val;
      this.getUserList();
    },
    chooseUser(currentLine) {
      if (this.selectedUser.length == 0) 
      {
        this.selectedUser.push(currentLine);
      } 
      else 
      {
        let isExit = false;
        this.selectedUser.forEach(item => {
          if (item.id == currentLine.id) {
            isExit = true;
          }
        });
        if (!isExit) {
          this.selectedUser.push(currentLine);
        }
      }
    },
    handleClose(tag) {
      this.selectedUser.splice(this.selectedUser.indexOf(tag), 1);
    },
    saveDialog() {
      if (this.selectedUser.length == 0) 
      {
        this.$alert("请选择用户。", "提示");
        return;
      }

      let userIdArray = this.selectedUser.map(item => {
        return item.id;
      });

      this.propsData.visible=false;
      this.$emit("chooseMultipleUserCallback", userIdArray);

    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">

.chooseMultipleUserDialog .el-dialog{
    top: 2vh !important;
    bottom: 2vh !important;
    left: 10% !important;
    right: 10% !important;
    width: 850px !important;
    height: 600px !important;

    .modalContent{
        position: absolute;
        top:10px;
        bottom: 90px;
        right: 20px;
        left: 20px;

    }

    .tree {
      width: 260px;
      float: left;
    }
    .rightDiv {
      width: calc(100% - 280px);
      float: right;
      height: 100%;
      position: relative;
    }
    .userTextarea {
      position: absolute;
      bottom: 0px;
      width: 96%;
      height:70px;
      border: 1px solid #bbbbbb;
      padding: 5px 10px;
    }
    .el-tag {
      margin-right: 5px;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/common/chooseMultipleUser.vue